/*
 *
 * ProtectionPlusModal
 *
 * @version 1.0.0
 * @author Mauro La Barbera
 * @since 01-Aug-2025
*/

import { connect } from 'react-redux'
import ProtectionPlusModal from './ProtectionPlusModal'
import { doHidePopup } from 'Store/actions/popup'
import { bindActionCreators } from 'redux'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doHidePopup }, dispatch)
})

const mapStateToProps = state => ({
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ProtectionPlusModal)
